const STORAGE_KEY = 'wishlist';

function getSaved() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch (error) {
    return [];
  }
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.updateState();
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    });

    document.addEventListener('wishlist:change', () => this.updateState());
  }

  isSaved() {
    return getSaved().includes(this.productId);
  }

  updateState() {
    const saved = this.isSaved();
    this.button.setAttribute('aria-pressed', String(saved));
    this.button.classList.toggle('is-saved', saved);
    this.button.setAttribute('aria-label', saved ? 'Remove from saved items' : 'Save for later');
  }

  toggle() {
    let saved = getSaved();
    const nowSaved = !saved.includes(this.productId);

    if (nowSaved) {
      saved.push(this.productId);
    } else {
      saved = saved.filter((id) => id !== this.productId);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    this.updateState();
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { productId: this.productId, saved: nowSaved } })
    );
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
